import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { useSelector } from 'react-redux';

import axios from "axios";
import { saveAs } from "file-saver";

import { contractCall, getAllbaroData } from "../../crud/auth.crud"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Pagination from "pages/Custom/Pagination";

import loading from "../../assets/images/loading.gif";

const AllbaroProcess = () => {

  const history = useHistory()

  // 드롭다운
  const [settingMenu, setSettingMenu] = useState(false)

  // useState가 list일 땐 목록창, detail일 땐 디테일창, modify일 땐 수정창
  const [form, setForm] = useState('list')

  const selector = useSelector(state => state);

  const [page, setPage] = useState(1)
  const [dataList, setDataList] = useState([])
  const [onUpload, setOnUpload] = useState(false);
  const [pagesGroup, setPagesGroup] = useState(1)
  const [pageArr, setPageArr] = useState([pagesGroup, pagesGroup + 1, pagesGroup + 2, pagesGroup + 3, pagesGroup + 4])
  const [contentCount, setContentCount] = useState()
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id);

  const getDataList = async () => {
    setOnUpload(true)

    const params = {
      page: page,
      company: companyId
    }

    const response = await getAllbaroData(params);
    let dataCount = response.data.count % 15 === 0 ? response.data.count / 15 : Math.floor(response.data.count / 15) + 1
    if (!contentCount || contentCount !== dataCount) {
      if(dataCount === 0){
        setContentCount(1)
      }else{
        setContentCount(dataCount)
      }
      let newArr = []
      for (let i = pagesGroup - 1; i < pagesGroup + 4; i++) {
        if (i + 1 <= dataCount) {
          newArr.push(i + 1)
        }
      }
      if(newArr.length === 0) newArr = [1]
      setPageArr(newArr)
    }
    if (typeof (response.data.count) === 'undefined') {
      setPageArr([1])
      setContentCount(1)
    }
    if (response.status === 200) {
      const content = response.data?.data || [];
      if (content.length > 0) {
        setDataList([...content])
      } else {
        setDataList(false)
      }
    }
    setOnUpload(false)
  }

  useEffect(() => {
    getDataList()
  }, [page])

  return (
    <React.Fragment>
      <Row>
        <Col md={12} lg={9} xl={6}>
          <div className="email-rightbar mb-3">
            <Card>
              <div className="radius-4 overflow-hidden">
                <div className="table-responsive">
                  <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                    <thead className="chart-thead">
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">거래처명</th>
                        <th scope="col">거래일자</th>
                        <th scope="col">입고량</th>
                      </tr>
                    </thead>
                    <tbody className="chart-tbody">

                      {
                        dataList && dataList.map((item, index) => {
                          return (
                            <tr key={item.id + '_' + index}>
                              <th>{item.id}</th>
                              <td>{item.company?.name}</td>
                              <td>{item.created_at.substr(0, 10)}</td>
                              <td>{item.qty}</td>
                            </tr>
                          )
                        })
                      }
                      {!dataList &&
                        <tr >
                          <td scope="row" colSpan="6">데이터가 없습니다.</td>
                        </tr>
                      }

                    </tbody>
                  </table>
                </div>
              </div>

            </Card>

            <Pagination contentCount={contentCount} pageArr={pageArr} pageCallBack={(page)=>{setPage(page)}} />

          </div>
        </Col>
        {onUpload && <div style={{
          position: "absolute",
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          background: 'rgba(255, 255, 255, 0.6)',
          zIndex: 999,
          display: "flex",
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <img src={loading} alt="로딩중입니다." width={'5%'}></img>
        </div>}
      </Row>
    </React.Fragment>
  )
}

export default AllbaroProcess
